




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AiFilterDTO } from '@/api';
import IconTimes from '@/assets/icons/times.svg';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';

type Param = { type: string; id: string };
type Category = { title: string; type: string; options: AiFilterDTO[]; };

@Component({
  name: 'ai-params',
  components: { IconTimes, IconArrowLeft },
})
export default class AiParams extends Vue {
  @Prop(Boolean) open!: boolean

  @Prop() value!: Param[]

  @Prop({ required: true }) categories!: Category[];

  selectedType: null | string = null;

  currentParams: Param[] = [];

  get selectedCategory() {
    return this.categories.find(c => c.type === this.selectedType);
  }

  get options() {
    return this.categories.find(c => c.type === this.selectedType) || [];
  }

  addOption(id: string) {
    if (this.selectedType) {
      const index = this.currentParams
        .findIndex(param => param.type === this.selectedType && param.id === id);
      if (index === -1) {
        this.currentParams.push({ type: this.selectedType, id });
      }
    }
  }

  removeOption(type: string, id: string) {
    const index = this.currentParams
      .findIndex(param => param.type === type && param.id === id);
    if (index > -1) {
      this.currentParams.splice(index, 1);
    }
  }

  selectCategoryType(value: string | null) {
    this.selectedType = value;
  }

  refreshState() {
    this.currentParams = Array.from(this.value);
    this.selectedType = null;
  }

  submit() {
    this.$emit('submit', this.currentParams);
    this.close();
  }

  clearFilters() {
    this.currentParams = [];
  }

  close() {
    this.$emit('close');
  }

  getTitle(param: Param) {
    const category = this.categories.find(c => c.type === param.type);
    const option = category?.options.find(o => o.id === param.id);
    return option ? option.name : 'Error';
  }
}
